import styled, { css } from 'styled-components';

// interface IContainerProps {
//   error?: string;
// }

export const ErrorMessage = styled.span`
  margin-top: 1.5px;
  align-self: flex-start;
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  font-size: 0.75rem;
  color: ${props => props.theme.error};
`;

export const Container = styled.div`
  ${({ disabled }) => disabled && `cursor: not-allowed;`};
  // Se quiser opacity no RichTextArea, substituir a linha acima pela debaixo
  /* ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.8;
      cursor: not-allowed;
    `} */
  border: ${props => (props.error ? '1px solid red' : 'none')};
  /* all: unset; */
  .jodit-wysiwyg {
    background: white;
    span,
    li,
    ul,
    strong,
    h1,
    h2,
    h3,
    h4,
    h5,
    p {
      /* font-family: initial !important; */
      font-size: initial;
      color: black;
      caret-color: black;
    }
  }
  ul,
  ol {
    padding-left: 20px;
    /* list-style: unset; */
  }
  /* border:1px solid red; */
`;
